import React, {useContext, useState} from "react";
import {Button} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import {httpRequestWithAuth} from "../../auth/axios_instance";
import {
    BaseFixClassAndRecurringForClientsURL,
    BaseFixClassAndRecurringWithoutTrainingAreaURL,
    BaseFixClassesGenderURL,
    BaseFixNoneCreatedByModifiedByURL
} from "../../urls";
import {AlertContext} from "../../store/use_context";
import {Hide} from "../../components/Hide";
import {Loading} from "../../components/Loading";


export const Actions = props => {
    const {setAlert} = useContext(AlertContext);
    const [is_loading, setIsLoading] = useState(false);

    const handleFixNoneCreatedByModifiedByBtn = async () => {
        await setIsLoading(true);
        let response = await httpRequestWithAuth(BaseFixNoneCreatedByModifiedByURL, "PATCH");

        if (response.status) {
            setAlert("Done");
        } else {
            setAlert("Error");
        }
        await setIsLoading(false);
    }

    const handleFixClassesGenderBtn = async () => {
        await setIsLoading(true);
        let response = await httpRequestWithAuth(BaseFixClassesGenderURL, "POST");

        if (response.status) {
            setAlert("Done");
        } else {
            setAlert("Error");
        }
        await setIsLoading(false);
    }

    const handleFixClassAndRecurringWithoutTrainingAreaBtn = async () => {
        await setIsLoading(true);
        let response = await httpRequestWithAuth(BaseFixClassAndRecurringWithoutTrainingAreaURL, "POST");

        if (response.status) {
            setAlert("Done");
        } else {
            setAlert("Error");
        }
        await setIsLoading(false);
    }

  const handleFixClassAndRecurringForClientsURLBtn = async () => {
        await setIsLoading(true);
        let response = await httpRequestWithAuth(BaseFixClassAndRecurringForClientsURL, "POST");

        if (response.status) {
            setAlert("Done");
        } else {
            setAlert("Error");
        }
        await setIsLoading(false);
    }


    return (
        <Paper className="flex-column align-items-center d-flex Paper">
            <Grid container spacing={2} className="mt-5">

                <Hide hide={!is_loading}>
                    <Loading/>
                </Hide>

                <Hide hide={is_loading}>

                    <Grid item xs={4}>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={() => {
                                props.history.push("/actions/view-class-attendance");
                            }}
                            fullWidth
                        >
                            View class attendance entity error
                        </Button>
                    </Grid>

                    <Grid item xs={4}>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={handleFixNoneCreatedByModifiedByBtn}
                            fullWidth
                        >
                            Fix none created by modified_by
                        </Button>
                    </Grid>


                    <Grid item xs={4}>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={() => {
                                props.history.push("/actions/view-none-created-by-modified-by-entity");
                            }}
                            fullWidth
                        >
                            View none created by, modified-by and entity
                        </Button>
                    </Grid>

                    <Grid item xs={4}>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={handleFixClassesGenderBtn}
                            fullWidth
                        >
                            Fix classes gender
                        </Button>
                    </Grid>


                    <Grid item xs={4}>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={handleFixClassAndRecurringWithoutTrainingAreaBtn}
                            fullWidth
                        >
                            Fix Classes An dRecurring Without Training Area
                        </Button>
                    </Grid>

                    <Grid item xs={4}>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={handleFixClassAndRecurringForClientsURLBtn}
                            fullWidth
                        >
                            Fix Class And Recurring For Clients
                        </Button>
                    </Grid>

                </Hide>
            </Grid>
        </Paper>
    )
}
